import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as RateCodeAction from './../../../../../actions/rateCodeAction';
import * as tourAction from './../../../../../actions/tourAction';
import * as supplierAction from './../../../../../actions/supplierAction';
import * as SupplierCategoryAction from '../../../../../actions/supplierCategoryAction';
import RateCodeDetail from './RateCodeDetail';

const mapStateToProps = state => {
    return {
        rateCodeState: state.rateCodeReducer,
        supplierState: state.supplierReducer,
        supplierCategoryState: state.supplierCategoryReducer,
        tourState: state.tourReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRateCodeDetail: (data) => dispatch(RateCodeAction.setRateCodeDetail(data)),
        getRateCodeCampaignList: (data) => dispatch(RateCodeAction.getRateCodeCampaignList(data)),
        getRateCodeDetail: (id) => dispatch(RateCodeAction.getRateCodeDetail(id)),
        getRateCodeSchedule: (id) => dispatch(RateCodeAction.getRateCodeSchedule(id)),
        createRateCodeSchedule: (rateCodeSchedule) => dispatch(RateCodeAction.createRateCodeSchedule(rateCodeSchedule)),
        createRateCodeDetail: (rateCode) => dispatch(RateCodeAction.createRateCodeDetail(rateCode)),
        updateRateCodeDetail: (rateCode) => dispatch(RateCodeAction.updateRateCode(rateCode)),
        createRateCodeCampaign: (campaign) => dispatch(RateCodeAction.createRateCodeCampaign(campaign)),
        getAllSupplierProduct: () => dispatch(supplierAction.getAllSupplierProduct()),
        getSupplierAll: () => dispatch(supplierAction.getSupplierListAll()),
        getSupplierCategoryListAll: () => dispatch(SupplierCategoryAction.getSupplierCategoryListAll()),  
        // getSuppliers: (params) => dispatch(supplierAction.getSupplierList(params)), //Thay all
        setRateCodeSchedule: (data) => dispatch(RateCodeAction.setRateCodeSchedule(data)),

        //TOUR TYPES
        getAllSurchargeCategories: () => dispatch(tourAction.getAllSurchargeCategories()),
        createSurchargeCategories: (surchargeCategories) => dispatch(tourAction.createSurchargeCategories(surchargeCategories)),
        getStockProducts: (params) => dispatch(RateCodeAction.getStockProducts(params)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RateCodeDetail));
